import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa774d50&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=aa774d50&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=aa774d50&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa774d50",
  null
  
)

export default component.exports